import * as React from 'react'

const SvgArrowUp = ({
  width,
  className,
}: {
  width: number
  className?: string
}) => (
  <svg
    className={className}
    width={width}
    height={width}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5781 15.8958L11.0052 15.2968C10.8837 15.1753 10.8229 15.0277 10.8229 14.8541C10.8229 14.6805 10.8837 14.533 11.0052 14.4114L16.0573 9.35935C16.1788 9.23783 16.3264 9.17706 16.5 9.17706C16.6736 9.17706 16.8212 9.23783 16.9427 9.35935L21.9948 14.4114C22.1163 14.533 22.177 14.6805 22.177 14.8541C22.177 15.0277 22.1163 15.1753 21.9948 15.2968L21.4218 15.8958C21.3003 16.0173 21.1527 16.0737 20.9791 16.0651C20.8055 16.0564 20.658 15.9913 20.5364 15.8698L17.5416 12.7448V22.8854C17.5416 23.059 17.4809 23.2065 17.3593 23.3281C17.2378 23.4496 17.0903 23.5104 16.9166 23.5104H16.0833C15.9097 23.5104 15.7621 23.4496 15.6406 23.3281C15.5191 23.2065 15.4583 23.059 15.4583 22.8854V12.7448L12.4635 15.8698C12.342 15.9913 12.1944 16.0564 12.0208 16.0651C11.8472 16.0737 11.6996 16.0173 11.5781 15.8958Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgArrowUp
